import * as React from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import Plot from 'shared/components/Chart/components/Plot';
import Curve from 'shared/components/Chart/components/Curve';
import InnerShadowFilter from 'shared/components/Chart/components/InnerShadowFilter';
import { MountainChartFragment_data as Point } from './__generated__/MountainChartFragment';
import { selector } from './selector';

import './index.scss';

export interface Props {
  data: Point[];
  width?: number;
  height?: number;
}

type Enhanced = Props & ReturnType<typeof selector>;

const enhance = compose<Enhanced, Props>(connect(selector));

class MountainChart extends React.Component<Enhanced> {
  render() {
    const { width, height, data, scales, values, plotGeo, areaBase } = this.props;

    return (
      <svg className="chart" width={width} height={height}>
        <defs>
          <InnerShadowFilter />
        </defs>
        {data && (
          <Plot className="idea-mountain-chart" geo={plotGeo}>
            <Curve data={data} scales={scales} values={values} areaBase={areaBase} />
          </Plot>
        )}
      </svg>
    );
  }
}

export default enhance(MountainChart);
